import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import AutocompleteField from "../../components/field/AutocompleteField";

import { useTranslation } from "react-i18next";
import { useForm } from "../../hooks/useForm";
import { useInvestmentSelectList } from "../../services/productsService";
import { useNotificationDrafts } from "../../services/draftsService";

export function SelectDrafNotifcationDialog(props) {
    const { t } = useTranslation();
    
    const { data: draftList } = useNotificationDrafts({draft_notification: props.draft_notification});

    const { formValue, onChangeAutocompleteFieldWithObjectOptions } = useForm({});

    const handleConfirm = () => {
        props.onConfirm(formValue.draft);
    };

    const handleClose = () => {
        props.onClose();
    };

    const hasSelectedDraft = formValue.draft;

    return (
        <Dialog open={props.open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("agreements.AgreementPassportDialog.selectDraft")}</DialogTitle>
            <DialogContent>
                <Grid item xs={12}>
                    <AutocompleteField
                        name="draft"
                        multiple={false}
                        addNewValue={false}
                        onChange={onChangeAutocompleteFieldWithObjectOptions}
                        options={draftList?.results || []}
                        label={t("agreements.AgreementPassportDialog.draft")}
                        isObjectOption
                        optionLabelKey="name"
                        value={formValue?.draft}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    {t("cancel")}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={!hasSelectedDraft}
                >
                    {t("confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
